import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton } from "@similarweb/ui-components";

import { StyledFindAppsMovedImg, StyledFindAppsMovedStateFlex } from "./styles";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import { Flex, Text } from "@similarweb/ui-components/foundations";
import { AssetsService } from "app/services/AssetsService";
import { colorsPalettes } from "@similarweb/styles";

const FindAppsRestrictedEmptyState = () => {
    const { translate } = useTranslate();

    const handleCtaClick = () => {
        siNavigator.goToAdvancedSearchPage(undefined, { pageSection: "apps", filtersCategory: "apps" });
    };

    return (
        <StyledFindAppsMovedStateFlex data-automation="si.find-apps.restricted-empty-state">
            <Flex
                flexDirection="column"
                alignItems="center"
                gap="32px"
                maxWidth="580px"
            >
                <Flex
                    flexDirection="column"
                    alignItems="center"
                    gap="16px"
                >
                    <Text
                        fontVariant="h2"
                        color={colorsPalettes.black["0"]}
                        textAlign="center"
                    >
                        {translate("si.find_apps.apps-moved-state.title")}
                    </Text>

                    <Text
                        fontVariant="body2"
                        color={colorsPalettes.carbon["500"]}
                        textAlign="center"
                    >
                        {translate("si.find_apps.apps-moved-state.message")}
                    </Text>

                    <StyledFindAppsMovedImg
                        src={AssetsService.assetUrl("/images/sales-intelligence/apps-moved-state.png")}
                        alt="apps-moved-state"
                    />
                </Flex>

                <IconButton
                    type="primary"
                    iconName="arrow-right"
                    placement="right"
                    onClick={handleCtaClick}
                >
                    {translate("si.find_apps.apps-moved-state.button.label")}
                </IconButton>
            </Flex>
        </StyledFindAppsMovedStateFlex>
    );
};

export default FindAppsRestrictedEmptyState;
